import { useTranslation } from 'react-i18next';

const AgentsStatusRender = ({ all }) => {
    const theme = localStorage.getItem("faTheme") === "light" ? 'black' : "white";

    const { t } = useTranslation();
    return (<svg>
        <text textAnchor="middle" x="40" y="40" style={{ fontSize: 20, fill: theme }}>
            <tspan x="100" style={{ fontWeight: 600, fontSize: "42px" }}>{all}</tspan>
            <tspan x="100" dy="30px" style={{ fontSize: "1.25rem", fill: theme }}>{t("total")}</tspan>
        </text>
    </svg>);
};

export default AgentsStatusRender;